<div *ngIf="selectedFilters.length > 0" class="selected-filters">
  <span
    *ngFor="let filter of selectedFilters"
    class="selected-filter"
    [ngClass]="getFilterClass(filter)"
  >
    <i class="material-icons">{{ getFilterIcon(filter) }}</i>
    {{ getFilterDisplayValue(filter) }}
    <button (click)="onRemoveFilter(filter)" class="remove-filter">
      <i class="fa fa-times"></i>
    </button>
  </span>
</div>
